import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext.js';
import { AppShell } from './components/AppShell.js';
import { AdminSettingsPage } from './pages/AdminSettings.js';
import { AIToolsPage } from './pages/AITools.js';
import { AutomationPage } from './pages/Automation.js';
import { LoginPage } from './pages/Login.js';
import { NotificationsPage } from './pages/Notifications.js';
import { OverviewPage } from './pages/Overview.js';
import { PriceCalcPage } from './pages/PriceCalc.js';
import { ResearchPage } from './pages/Research.js';
import { SettingsPage } from './pages/Settings.js';
import { TrendsPage } from './pages/Trends.js';
import { VendorsPage } from './pages/Vendors.js';

function RequireAuth(): JSX.Element {
  const { ready, isAuthed } = useAuth();
  const location = useLocation();
  if (!ready) return <div style={{ padding: 24 }}>Loading…</div>;
  if (!isAuthed) return <Navigate to="/login" state={{ from: location }} replace />;
  return <Outlet />;
}

export function Router(): JSX.Element {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<RequireAuth />}>
            <Route element={<AppShell />}>
              <Route path="/" element={<OverviewPage />} />
              <Route path="/research" element={<ResearchPage />} />
              <Route path="/vendors" element={<VendorsPage />} />
              <Route path="/ai-tools" element={<AIToolsPage />} />
              <Route path="/price-calc" element={<PriceCalcPage />} />
              <Route path="/automation" element={<AutomationPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/trends" element={<TrendsPage />} />
              <Route path="/admin/settings" element={<AdminSettingsPage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
